module.exports = __webpack_public_path__ + "static/media/6.26ab1d9d.jpg";